export type EventType = '理監事會議' | '月例會' | '聯誼會' | '全國社活動' | '子社團活動';

export interface ClubEvent {
  id: number;
  month: number;
  monthLabel: string;
  date: string;
  title: string;
  type: EventType;
  description: string;
  location: string;
  director?: string;
}

export const EVENT_TYPES: EventType[] = ['理監事會議', '月例會', '聯誼會', '全國社活動', '子社團活動'];

export const EVENT_TYPE_COLORS: Record<EventType, { bg: string; text: string; border: string }> = {
  理監事會議: { bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200' },
  月例會: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
  聯誼會: { bg: 'bg-teal-50', text: 'text-teal-700', border: 'border-teal-200' },
  全國社活動: { bg: 'bg-orange-50', text: 'text-orange-700', border: 'border-orange-200' },
  子社團活動: { bg: 'bg-stone-100', text: 'text-stone-700', border: 'border-stone-300' },
};

export const MONTH_NAMES: Record<number, string> = {
  1: 'JAN', 2: 'FEB', 3: 'MAR', 4: 'APR',
  5: 'MAY', 6: 'JUN', 7: 'JUL', 8: 'AUG',
  9: 'SEP', 10: 'OCT', 11: 'NOV', 12: 'DEC',
};

export const clubEvents: ClubEvent[] = [
  // ── 一月 ──
  {
    id: 1,
    month: 1, monthLabel: 'JAN',
    date: '1/1（四）',
    title: '元旦登山',
    type: '聯誼會',
    description: '迎接新年，社友共同登山健行，在山頂眺望台北盆地，迎接 2026 年第一道曙光。',
    location: '台北近郊',
  },
  {
    id: 2,
    month: 1, monthLabel: 'JAN',
    date: '1/7（三）',
    title: '一月理監事會議',
    type: '理監事會議',
    description: '2026 年首次理監事聯席會議，確認全年度工作計畫與重大決策事項。',
    location: '社址會議室',
  },
  {
    id: 3,
    month: 1, monthLabel: 'JAN',
    date: '1/28（三）',
    title: '建立企業韌性',
    type: '月例會',
    description: '邀請專家分析 2026 年台灣城市發展趨勢，探討智慧城市與公益商業機會。',
    location: 'YMMC',
    director: '賴明德',
  },

  // ── 二月 ──
  {
    id: 4,
    month: 2, monthLabel: 'FEB',
    date: '2/4（三）',
    title: '二月理監事會議',
    type: '理監事會議',
    description: '檢視一月工作執行狀況，討論春節系列活動籌備進度。',
    location: '社址會議室',
  },
  {
    id: 5,
    month: 2, monthLabel: 'FEB',
    date: '2/7（六）',
    title: '企業參訪',
    type: '聯誼會',
    description: '參訪標竿企業，深度了解企業運營模式，與高階主管交流座談，擴展社友視野。',
    location: '台北科技走廊',
  },
  {
    id: 6,
    month: 2, monthLabel: 'FEB',
    date: '2/28（六）',
    title: '春節團拜',
    type: '月例會',
    description: '農曆年後首次大型聚會，全體社友齊聚一堂，共享新春喜氣，增進情誼。',
    location: '北投會館',
    director: '陳玲',
  },

  // ── 三月 ──
  {
    id: 7,
    month: 3, monthLabel: 'MAR',
    date: '3/4（三）',
    title: '三月理監事會議',
    type: '理監事會議',
    description: '第一季工作檢討暨第二季計畫審議，確保社務推動符合年度目標。',
    location: '社址會議室',
  },
  {
    id: 8,
    month: 3, monthLabel: 'MAR',
    date: '3/14-15（六、日）',
    title: '全國登山活動',
    type: '全國社活動',
    description: '與全國各地青企社友共同參與的年度登山盛會，跨城市交流、增廣見聞。',
    location: '全國指定登山地點',
  },
  {
    id: 9,
    month: 3, monthLabel: 'MAR',
    date: '3/25（三）',
    title: '如何避免「AI」的詐騙陷阱',
    type: '月例會',
    description: '特邀資安專家主講，深度剖析 AI 時代詐騙手法，提供社友防範實用指南。',
    location: '晶宴會館-民權館',
    director: '胡瀞云',
  },

  // ── 四月 ──
  {
    id: 10,
    month: 4, monthLabel: 'APR',
    date: '4/1（三）',
    title: '四月理監事會議',
    type: '理監事會議',
    description: '審議上半年預算執行，確認第二季重點活動方向與資源分配。',
    location: '社址會議室',
  },
  {
    id: 11,
    month: 4, monthLabel: 'APR',
    date: '4/11（六）',
    title: '青企高爾夫',
    type: '聯誼會',
    description: '青企社友高爾夫同好聯誼，以球會友，在球場上建立深厚情誼與人脈。',
    location: '台北近郊高爾夫球場',
  },
  {
    id: 12,
    month: 4, monthLabel: 'APR',
    date: '4/24（五）',
    title: '全國高爾夫球聯誼賽',
    type: '全國社活動',
    description: '一年一度全國青企高爾夫球聯誼賽，結合競技與交流，擴大跨社人脈網絡。',
    location: '全國高爾夫俱樂部',
  },
  {
    id: 13,
    month: 4, monthLabel: 'APR',
    date: '4/29（三）',
    title: '新南向新商機【國際機會面】',
    type: '月例會',
    description: '深入分析東南亞市場最新動態，為有意布局新南向市場的社友提供實戰情報。',
    location: '晶宴會館-民權館',
    director: '陳宥亘',
  },

  // ── 五月 ──
  {
    id: 14,
    month: 5, monthLabel: 'MAY',
    date: '5/6（三）',
    title: '五月理監事會議',
    type: '理監事會議',
    description: '確認第二季活動執行進度，討論暑期系列活動籌備細節。',
    location: '社址會議室',
  },
  {
    id: 15,
    month: 5, monthLabel: 'MAY',
    date: '5/27（三）',
    title: '東協產業趨勢與發展現況分析與機會',
    type: '月例會',
    description: '針對東協十國產業結構演變進行深度分析，協助社友掌握區域布局契機。',
    location: '晶宴會館-民權館',
    director: '湯宗霖',
  },
  {
    id: 16,
    month: 5, monthLabel: 'MAY',
    date: '5/30（六）',
    title: '捐血活動',
    type: '聯誼會',
    description: '響應社會公益，組織社友共同捐血，並於活動後舉辦輕鬆聯誼餐敘，共襄善舉。',
    location: '台北捐血中心',
  },

  // ── 六月 ──
  {
    id: 17,
    month: 6, monthLabel: 'JUN',
    date: '6/3（三）',
    title: '六月理監事會議',
    type: '理監事會議',
    description: '上半年社務總檢討，確認參訪團行前準備與下半年活動最終確認。',
    location: '社址會議室',
  },
  {
    id: 18,
    month: 6, monthLabel: 'JUN',
    date: '6/6-7（六、日）',
    title: '全國大露營',
    type: '全國社活動',
    description: '全國青企社友共同參與的年度露營活動，在大自然中放鬆身心、深化跨社情誼。',
    location: '全國指定露營地',
  },
  {
    id: 19,
    month: 6, monthLabel: 'JUN',
    date: '6/18-21',
    title: '青企參訪團（大陸、東協）',
    type: '聯誼會',
    description: '率領社友前往大陸及東南亞重點城市考察，拜會當地企業與商業組織，開拓國際視野。',
    location: '大陸 / 東南亞地區',
  },
  {
    id: 20,
    month: 6, monthLabel: 'JUN',
    date: '6/24（三）',
    title: '大陸目前發展現況分析與機會',
    type: '月例會',
    description: '邀請大陸台商代表分享第一線觀察，剖析兩岸經貿最新發展趨勢與商機。',
    location: '晶宴會館-民權館',
    director: '黃安邦',
  },

  // ── 七月 ──
  {
    id: 21,
    month: 7, monthLabel: 'JUL',
    date: '7/1（三）',
    title: '七月理監事會議',
    type: '理監事會議',
    description: '下半年工作計畫總部署，確認各委員會任務分工與執行時程。',
    location: '社址會議室',
  },
  {
    id: 22,
    month: 7, monthLabel: 'JUL',
    date: '7/11（六）',
    title: '北海岸海釣',
    type: '聯誼會',
    description: '暑假限定！出海體驗海釣樂趣，在浪花與陽光中放鬆身心，增進社友情誼。',
    location: '基隆八斗子漁港',
  },
  {
    id: 23,
    month: 7, monthLabel: 'JUL',
    date: '7/29（三）',
    title: 'EMBA 大師【社務面】',
    type: '月例會',
    description: '邀請知名 EMBA 學者主講，分享最前沿的管理思維與領導力發展洞見。',
    location: '晶宴會館-民權館',
    director: '陳威丞',
  },

  // ── 八月 ──
  {
    id: 24,
    month: 8, monthLabel: 'AUG',
    date: '8/5（三）',
    title: '八月理監事會議',
    type: '理監事會議',
    description: '確認年度下半場各項活動細節，審議社務發展大會議程。',
    location: '社址會議室',
  },
  {
    id: 25,
    month: 8, monthLabel: 'AUG',
    date: '8/15（六）',
    title: '鼎廬夜談',
    type: '聯誼會',
    description: '傳統社友私塾夜談，在雅致氛圍中品茶論道，深度分享人生歷練與商業智慧。',
    location: '內湖私人會所',
  },
  {
    id: 26,
    month: 8, monthLabel: 'AUG',
    date: '8/26（三）',
    title: '社務發展大會【社務面】',
    type: '月例會',
    description: '全體社友共同參與的社務發展大會，審視年度進展，凝聚社群共識與發展方向。',
    location: '晶宴會館-民權館',
    director: '李境峰',
  },

  // ── 九月 ──
  {
    id: 27,
    month: 9, monthLabel: 'SEP',
    date: '9/2（三）',
    title: '九月理監事會議',
    type: '理監事會議',
    description: '確認全國年會出席事宜及第四季活動準備工作。',
    location: '社址會議室',
  },
  {
    id: 28,
    month: 9, monthLabel: 'SEP',
    date: '9/19-20（六、日）',
    title: '全國年會活動',
    type: '全國社活動',
    description: '一年一度全國青企年會，匯聚全台分社社友，表彰年度傑出貢獻，交流豐碩成果。',
    location: '全國年會指定地點',
  },
  {
    id: 29,
    month: 9, monthLabel: 'SEP',
    date: '9/30（三）',
    title: '社員大會（領導專題）',
    type: '月例會',
    description: '全體社員出席大會，進行本年度社務報告、財務報告，並以領導力為核心主題深度探討。',
    location: '晶宴會館-民權館',
    director: '蘇育民',
  },

  // ── 十月 ──
  {
    id: 30,
    month: 10, monthLabel: 'OCT',
    date: '10/7（三）',
    title: '十月理監事會議',
    type: '理監事會議',
    description: '第三季工作總檢討，確認年底收尾各項計畫與社長交接籌備。',
    location: '社址會議室',
  },
  {
    id: 31,
    month: 10, monthLabel: 'OCT',
    date: '10/15-18',
    title: '青企參訪團（大陸、東協）',
    type: '聯誼會',
    description: '秋季海外考察行程，深化台灣青企與大陸、東南亞企業界的交流合作網絡。',
    location: '大陸 / 東南亞地區',
  },
  {
    id: 32,
    month: 10, monthLabel: 'OCT',
    date: '10/28（三）',
    title: '新創產業發展分析與機會【新創面】',
    type: '月例會',
    description: '聚焦台灣新創生態系，邀請知名創投人士分享投資趨勢與新創扶植心法。',
    location: '晶宴會館-民權館',
    director: '薛英林',
  },

  // ── 十一月 ──
  {
    id: 33,
    month: 11, monthLabel: 'NOV',
    date: '11/4（三）',
    title: '十一月理監事會議',
    type: '理監事會議',
    description: '年末社務總盤點，確認社長交接籌備工作及年終晚會各項細節。',
    location: '社址會議室',
  },
  {
    id: 34,
    month: 11, monthLabel: 'NOV',
    date: '11/7-8（六、日）',
    title: '全國傳承營活動',
    type: '全國社活動',
    description: '全台新舊社友共同參與的傳承訓練營，承接青企精神，培育下一代領袖人才。',
    location: '日月潭教師會館',
  },
  {
    id: 35,
    month: 11, monthLabel: 'NOV',
    date: '11/25（三）',
    title: '創投產業分析與機會',
    type: '月例會',
    description: '深入分析 2026 年創投環境，探討台灣 VC/PE 市場機遇與風險管理策略。',
    location: '晶宴會館-民權館',
    director: '陳其駿',
  },

  // ── 十二月 ──
  {
    id: 36,
    month: 12, monthLabel: 'DEC',
    date: '12/2（三）',
    title: '十二月理監事會議',
    type: '理監事會議',
    description: '年度最後一次理監事會議，確認社長交接典禮及年終晚會各項安排。',
    location: '社址會議室',
  },
  {
    id: 37,
    month: 12, monthLabel: 'DEC',
    date: '12月',
    title: '社長交接暨年終晚會',
    type: '聯誼會',
    description: '2026 年度最後一場盛大活動，社長正式交接棒，全體社友共同歡慶一年的豐碩成果。',
    location: '台北喜來登大飯店',
    director: '陳以欣',
  },
];
